import { render, staticRenderFns } from "./seguimiento-objetivos.vue?vue&type=template&id=055edff6&scoped=true&"
import script from "./seguimiento-objetivos.vue?vue&type=script&lang=js&"
export * from "./seguimiento-objetivos.vue?vue&type=script&lang=js&"
import style0 from "./seguimiento-objetivos.vue?vue&type=style&index=0&id=055edff6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055edff6",
  null
  
)

export default component.exports